// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createHook, type BoundActions, type HookFunction } from '@atlassian/react-sweet-state';
import { PermissionsStore, type Actions } from './PermissionsContainer.tsx';
import type { State } from './State.types.tsx';

export const useIsCollectionView: HookFunction<
	boolean,
	BoundActions<State, Actions>,
	void
> = createHook(PermissionsStore, {
	selector: (state) => state.meta.loadingProps?.isCollectionView || false,
});
